module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-cs.1c1ae13293bc783e0deb.svg";